import React, { memo } from 'react';
import dlv from 'dlv';
import { ImageProps } from 'next/image';

interface PictureProps extends Omit<ImageProps, 'src' | 'alt'> {
  mobile?: any;
  desktop?: any;
  className?: string;
  caption?: string;
  title?: string;
}

const Picture = ({ caption, mobile, desktop, className, title, ...restProps }: PictureProps) => {
  if (!mobile || !desktop) {
    return null;
  }

  const { url, width, height, formats = {}, alternativeText } = mobile ?? desktop;
  const dsk = desktop ?? mobile;
  const { url: dskUrl, formats: dksFormats } = dsk;

  return (
    <picture>
      <source media="(max-width: 480px)" srcSet={dlv(formats, 'small.url', url)} />
      <source
        media="(min-width: 481px) and (max-width: 768px)"
        srcSet={dlv(formats, 'medium.url', url)}
      />
      <source
        media="(min-width: 769px) and (max-width: 992px)"
        srcSet={dlv(dksFormats, 'small.url', dskUrl)}
      />
      <source
        media="(min-width: 993px) and (max-width: 1200px)"
        srcSet={dlv(dksFormats, 'medium.url', dskUrl)}
      />
      <source media="(min-width: 1201px)" srcSet={dlv(dksFormats, 'large.url', dskUrl)} />
      <img
        src={url}
        alt={alternativeText ?? caption ?? title}
        className={className}
        width={width}
        height={height}
        {...restProps}
      />
    </picture>
  );
};

export default memo(Picture);
